import type { AxiosResponseHeaders } from 'axios';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function capitalizeFirstLetter(value: string) {
  return `${value.charAt(0).toLocaleUpperCase()}${value.slice(1)}`;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parsePaginationHeaders(headers: AxiosResponseHeaders) {
  return {
    currentPage: Number(headers['x-pagination-current-page']),
    lastPage: Number(headers['x-pagination-last-page']),
    pageSize: Number(headers['x-pagination-page-size']),
    totalCount: Number(headers['x-pagination-total-count']),
  };
}
